import { render, staticRenderFns } from "./accountVIVO.vue?vue&type=template&id=c9be5184"
import script from "./accountVIVO.vue?vue&type=script&lang=js"
export * from "./accountVIVO.vue?vue&type=script&lang=js"
import style0 from "./accountVIVO.vue?vue&type=style&index=0&id=c9be5184&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports